import './Messages.css';

const MESSAGES = [
  {
    id: '1',
    platform: 'TakeTitle',
    platformIcon: '🏛️',
    subject: 'Investment Confirmation Required',
    preview: 'Your investment in Property #4521 requires confirmation...',
    time: '10 min ago',
    unread: true,
  },
  {
    id: '2',
    platform: 'TakeTitle',
    platformIcon: '🏛️',
    subject: 'Governance Proposal #127',
    preview: 'A new governance proposal has been submitted for your review...',
    time: '2 hours ago',
    unread: true,
  },
  {
    id: '3',
    platform: 'TrueResolve',
    platformIcon: '⚖️',
    subject: 'Case Update: #TR-2024-0892',
    preview: 'The mediation session has been scheduled for...',
    time: 'Yesterday',
    unread: false,
  },
  {
    id: '4',
    platform: 'eStream Console',
    platformIcon: '⬡',
    subject: 'Network Alert: Node Maintenance',
    preview: 'Scheduled maintenance window for node cluster alpha-3...',
    time: '2 days ago',
    unread: false,
  },
];

export default function Messages() {
  const unreadCount = MESSAGES.filter(m => m.unread).length;

  return (
    <div className="messages-page animate-in">
      {/* Header */}
      <div className="messages-header">
        <div className="messages-filters">
          <button className="filter-btn active">All</button>
          <button className="filter-btn">Unread ({unreadCount})</button>
          <button className="filter-btn">TakeTitle</button>
          <button className="filter-btn">TrueResolve</button>
          <button className="filter-btn">eStream</button>
        </div>
      </div>

      {/* Message List */}
      <div className="messages-list">
        {MESSAGES.map((message) => (
          <div 
            key={message.id} 
            className={`message-card card ${message.unread ? 'unread' : ''}`}
          >
            <div className="message-platform">
              <span className="platform-icon">{message.platformIcon}</span>
              <span className="platform-name">{message.platform}</span>
            </div>
            <div className="message-content">
              <h3 className="message-subject">{message.subject}</h3>
              <p className="message-preview">{message.preview}</p>
            </div>
            <div className="message-meta">
              <span className="message-time">{message.time}</span>
              {message.unread && <span className="unread-dot"></span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
